import React from 'react';
import {SectionMain, Tabs, Tab} from 'components/core';
import UsersList from './list';
import Singletons from 'controllers/Singletons';
import UsersDialog from './dialog';
import UserPanel from './panel';

export default function Users()
{
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [panelUser, setPanelUser] = React.useState(null);


    const handleNewButtonClick = () =>
    {
      setDialogOpen(true);
    }

    const handleTabChange = (index) =>
    {
      if(index !== selectedTab)
      {
        setPanelUser(null);
        setSelectedTab(index);
      }
    }
  
    const handleNewDialogClose = () => {
      setDialogOpen(false);
    };

    const tabs = <Tabs value={selectedTab} onChange={(evt, index) => handleTabChange(index)} textColor="primary" indicatorColor="primary">
        <Tab label="Usuarios Activos"/>
        <Tab label="Usuarios Desactivados"/>
    </Tabs>

    const panel = <UserPanel userID={panelUser} onClose={()=>setPanelUser(null)} open={panelUser !== null} />;

    return <SectionMain title="Usuarios" detail={panel} showDetail={panelUser !== null} buttonLabel="Nuevo Usuario" tabs={tabs} onButtonClick={() => handleNewButtonClick()} buttonDisabled={Singletons.currentUser.profiles.indexOf("administrators") === -1}>
      <UsersDialog 
      open={dialogOpen}
      onClose={handleNewDialogClose}
      onConfirm={handleNewDialogClose}
      />
      <UsersList onRowSelected={(row) => setPanelUser(row.userID)} dataset={selectedTab === 0 ? "open": "closed"}/>
    </SectionMain>
}
